import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { Button, Col, Row } from 'react-bootstrap';
import { FaCheckCircle, FaTrash, FaTrashRestore } from 'react-icons/fa';

import { isValid } from 'date-fns';
import { useToast } from '../../../../hooks/toast';

import { IParcelas } from '../../../../pages/CartaoSaudeDetalhe';
import InputMoneyClick from '../../../InputMoneyClick';
import InputMaskClick from '../../../InputMaskClick';
import api from '../../../../services/api';
import getResponseErrors from '../../../../utils/getResponseErrors';
import Loading from '../../../Loading';

// import { Container } from './styles';

interface FormDados {
  CprValor: number;
  CprDataVenc: string;
}
type ComponentProps = {
  parcela: IParcelas;
  handleAlteraExcluida(cprCodigo: number): void;
};
const ItemManutencao: React.FC<ComponentProps> = ({
  parcela,
  handleAlteraExcluida,
}) => {
  const { addToast } = useToast();
  const formRefParcela = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const InitialData: FormDados = {
    CprValor: parcela.CprValor,
    CprDataVenc: parcela.CprDataVencFormatado,
  };

  const toISOFormat = useCallback((dateTimeString: string): Date => {
    // Primeiro, dividimos a data completa em duas partes:
    const [date, time] = dateTimeString.split(' ');

    // Dividimos a data em dia, mês e ano:
    const [DD, MM, YYYY] = date.split('/');

    // Dividimos o tempo em hora e minutos:
    // const [HH, mm] = time.split(':');

    // Retornamos a data formatada em um padrão compatível com ISO:
    return new Date(`${YYYY}-${MM}-${DD}T03:01`);
  }, []);

  const handleSubmit = useCallback(
    async (dados: FormDados) => {
      try {
        const dataVenc = toISOFormat(dados.CprDataVenc);
        if (!isValid(dataVenc)) {
          addToast({
            title: 'Data Inválida',
            type: 'error',
          });

          return;
        }
        setLoading(true);

        await api.patch(`/pagamento/AlterarDados/${parcela.CprCodigo}`, {
          CprDataVenc: dataVenc,
          CprValor: dados.CprValor,
        });
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro alterar parcela',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, toISOFormat, parcela],
  );

  const handleAtivarDesativar = useCallback(async () => {
    try {
      setLoading(true);
      await api.patch(`/pagamento/ativarDesativar/${parcela.CprCodigo}`, {
        CprExcluida: !parcela.CprExcluida,
      });
      handleAlteraExcluida(parcela.CprCodigo);
    } catch (error: any) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        type: 'error',
        title: 'Erro alterar parcela',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, parcela, handleAlteraExcluida]);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      <Form
        ref={formRefParcela}
        initialData={InitialData}
        onSubmit={handleSubmit}
      >
        <Row noGutters className="bg-light text-dark p-1">
          <Col md={1} className="px-1">
            {parcela.CprCodigo}
          </Col>
          <Col md={2} className="px-1">
            {parcela.CprHistorico}
          </Col>
          <Col md={1} className="px-1">
            {parcela.CprPagoFormatado}
          </Col>
          <Col md={1} className="px-1">
            {parcela.CprParcelaAtiva ? 'Sim' : 'Não'}
          </Col>
          <Col md={1} className="px-1">
            {parcela.CprExcluida ? 'Sim' : 'Não'}
          </Col>
          <Col md={2} className="px-1">
            <InputMaskClick
              name="CprDataVenc"
              mask="99/99/9999"
              minLength={10}
              disabled={parcela.CprPago}
            />
          </Col>

          <Col md={2} className="px-1">
            <InputMoneyClick name="CprValor" disabled={parcela.CprPago} />
          </Col>
          <Col
            md={2}
            className="d-flex justify-content-between align-items-center px-1"
          >
            <Button
              data-id={parcela.CprCodigo}
              type="submit"
              size="sm"
              style={{ padding: '1px 8px' }}
              className="bg-success"
              disabled={parcela.CprPago}
            >
              <FaCheckCircle size={14} />
            </Button>

            <Button
              type="button"
              size="sm"
              variant={
                !parcela.CprExcluida ? 'outline-danger' : 'outline-primary'
              }
              style={{ padding: '1px 8px' }}
              onClick={handleAtivarDesativar}
              title={!parcela.CprExcluida ? 'Excluir' : 'Restaurar'}
              disabled={parcela.CprPago}
            >
              {!parcela.CprExcluida && <FaTrash size={14} />}
              {parcela.CprExcluida && <FaTrashRestore size={14} />}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ItemManutencao;
